import React, { ComponentProps, FC, ReactElement } from 'react';

import Markdown from 'markdown-to-jsx';

import { Chip } from './Chip';

export const EventChip: FC<{
  label: string;
  variant?: ComponentProps<typeof Chip>['variant'];
  size?: ComponentProps<typeof Chip>['size'];
  startIcon: string | ReactElement;
  onClick?: () => void;
}> = ({ label, startIcon, size = 'sm', variant, onClick }) => {
  return (
    <Chip
      label={
        <div className="d-flex align-items-center gap-1">
          {typeof startIcon === 'string' ? (
            <Markdown options={{ forceBlock: true, forceWrapper: true }} style={{ fontSize: 14 }}>
              {startIcon}
            </Markdown>
          ) : (
            startIcon
          )}
          <div>{label}</div>
        </div>
      }
      variant={variant}
      color="neutral"
      size={size}
      onClick={onClick}
    />
  );
};
